<template>
  <Dialog :open="showModal" @update:open="onDialogUpdate">
    <DialogScrollContent>
      <DialogHeader>
        <DialogTitle>
          {{ $t('Select Activity Variant(s)')}}
        </DialogTitle>
      </DialogHeader>
      <ActivitiesAndVariantsSelector
        :activities-select-list="activitiesSelectList"
        :variants-selected="variantsSelected"
        :activity-default="activityDefault"
        @change-variants-list="variantsSelectedList = $event"
      >
      </ActivitiesAndVariantsSelector>
      <DialogFooter>
        <button
          @click.prevent="emitVariantsSelectedListHideModal"
          class="btn btn-primary"
        >
          {{ $t('Save') }}
        </button>
      </DialogFooter>
    </DialogScrollContent>
  </Dialog>
</template>

<script>
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import ActivitiesAndVariantsSelector from "@/components/ActivitiesAndVariantsSelector.vue";

export default {
  components: { DialogFooter, ActivitiesAndVariantsSelector, DialogTitle, DialogHeader, DialogScrollContent, Dialog },
  props: {
    variantsSelected: {
      type: Array,
      default: function () {
        return [];
      }
    },
    activitiesSelectList: {
      required: true,
      type: Array,
    },
    activityDefault: {
      required: true,
      type: Number,
    },
    showModal: {
      required: true,
      type: Boolean,
    }
  },
  data() {
    return {
      selectedActivity: 0,
      variantsSelectedList: [],
    }
  },
  methods: {
    onDialogUpdate(isOpen) {
      if (!isOpen) {
        this.$emit('modal-close')
      }
    },
    emitVariantsSelectedListHideModal() {
      this.$emit('send-variants-list', this.variantsSelectedList)
    },
  },
  watch: {
    activityDefault: function (val) {
      this.selectedActivity = val
    },
  },
  mounted() {
    this.variantsSelectedList = this.variantsSelected
  },
}
</script>

<style scoped>

</style>
